import React from 'react';
import Column from 'shared/components/column';
import {SemiBoldText} from 'shared/components/text';
import useCart from '../util/use-cart';
import styled from 'styled-components';
import Row from 'shared/components/row';
import Mask, {masks} from 'shared/util/mask';

const CartUser: React.FC = () => {
  const {guestUser, setGuestUser, userByPhoneQuery, userQuery} = useCart();

  return (
    <Column>
      <SemiBoldText style={{marginBottom: 15}} size="large">
        Cliente
      </SemiBoldText>
      <Column gap={10}>
        <Column gap={5}>
          <SemiBoldText size="small">Nome*</SemiBoldText>
          <Input
            placeholder="Nome do cliente"
            onChange={(e) => setGuestUser({...guestUser, name: e.target.value})}
            value={guestUser?.name}
            disabled={!!userByPhoneQuery.data || !!userQuery.data}
          />
        </Column>
        <Row gap={15}>
          <Column gap={5} style={{flex: 1, height: 65}}>
            <SemiBoldText size="small">Telefone*</SemiBoldText>
            <Input
              placeholder="Telefone do cliente"
              onChange={(e) =>
                setGuestUser({
                  ...guestUser,
                  phone: Mask.unMask(e.target.value ?? ''),
                })
              }
              value={masks.phone(guestUser?.phone)}
              disabled={!!userQuery.data}
            />
          </Column>
          <Column gap={5} style={{flex: 1, height: 65}}>
            <SemiBoldText size="small">Cpf</SemiBoldText>
            <Input
              placeholder="CPF do cliente"
              onChange={(e) =>
                setGuestUser({
                  ...guestUser,
                  document: Mask.unMask(e.target.value ?? ''),
                })
              }
              value={masks.cpf(guestUser?.document ?? '')}
              disabled={!!userByPhoneQuery.data || !!userQuery.data}
            />
          </Column>
        </Row>
        <Column gap={5}>
          <SemiBoldText size="small">E-mail</SemiBoldText>
          <Input
            placeholder="Email do cliente"
            onChange={(e) =>
              setGuestUser({...guestUser, email: e.target.value})
            }
            value={guestUser?.email}
            disabled={!!userByPhoneQuery.data || !!userQuery.data}
          />
        </Column>
      </Column>
    </Column>
  );
};

export default CartUser;

const Input = styled.input`
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 4px;
  padding: 10px;
`;
